import type { ListBuilderList } from '../../../types';
import { createCompletedTaskColumns } from '../columns';

/**
 * Completed Tasks list configuration
 * Shows completed tasks from the last 7 days
 * Note: Uses different columns (no complete-column)
 */
export const completedTasksList: ListBuilderList = {
	id: 'completed-tasks',
	cacheTTL: 300000,
	name: 'Completed',
	type: 'default',
	active: true,
	sortOrder: 6,
	activeFilters: [
		'taskKeywords',
		'taskStatus',
		'taskPriority',
		'taskLinkType',
		'taskAssignedUser',
		'taskTeams',
		'taskClient',
		'taskClientRep',
		'taskLeadOrCustomer',
		'taskCompletedDateRange',
	],
	columns: createCompletedTaskColumns(),
	defaultSortId: 'column-completed-date-column-desc',
	filterRules: {
		taskAssignedUser: {
			// PD-15470: a default, deliberately NOT a lock. The list still opens
			// on "my tasks", but a rep without `tasks:view:any` can now widen the
			// assignee filter to see a colleague's task on an account they rep.
			// The lock used to be the only thing scoping this list, and because
			// the controller feeds an enforced value straight into the query it
			// also ANDed away the new union. Visibility is now bounded
			// server-side by TasksService (`queryTasks` and `queryCalendarTasks`
			// both apply "assigned to me OR client in my book"), so widening the
			// filter here cannot widen what the API returns.
			defaultValue: [{ id: 'ME', label: 'Me' }],
		},
		taskStatus: {
			defaultValue: [{ id: 'completed', label: 'Completed' }],
		},
		taskCompletedDateRange: {
			defaultValue: [
				{
					id: 'last-7-days',
					label: 'Last 7 Days',
					data: {
						startDate: '{{DATE:-7d}}',
						endDate: '{{DATE:0d}}',
					},
				},
			],
		},
	},
};
